const { default: BaseInterpreterProvider } = require("./BaseProvider");

class DesktopProvider extends BaseInterpreterProvider {
  constructor(baseUrl = "") {
    super();

    this.baseUrl = baseUrl;
  }

  async getConfiguration() {}

  async getLanguages() {}

  async sendInvite(payload) {}

  async getInviteStatus(requestID) {}

  async completeInviteRequest(requestID) {}
}

export default DesktopProvider;
